import { Colors } from "@/enums/Colors";
import { styled, ToggleButton, toggleButtonClasses, ToggleButtonGroup, toggleButtonGroupClasses, typographyClasses } from "@mui/material";

export const FilterToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
  display: "flex",
  gap: "0.5rem",
  width: "100%",
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    ":not(:last-of-type :first-of-type)": { borderRadius: "0.25rem" },
    ":is(:last-of-type :first-of-type)": { borderRadius: "0.25rem" },
  },
}));

export const FilterToggleButton = styled(ToggleButton)(() => ({
  [`&.${toggleButtonClasses.root}`]: {
    height: "1.625rem",
    flex: "1",
    padding: 0,
    borderRadius: "0.25rem",
    border: 0,
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: Colors.BUTTON_GRAY_HOVER_E2E6E9,
    },
    textTransform: "none",
    backgroundColor: Colors.LIGHT_GRAY_F4F4F4,
    [`& .${typographyClasses.root}`]: {
      color: Colors.ELEGANT_BLACK,
      fontSize: "0.75rem",
      fontWeight: "500",
    },
    [`&.${toggleButtonClasses.selected}`]: {
      backgroundColor: Colors.DARK_GREY_3E3E3E,
      [`& .${typographyClasses.root}`]: {
        color: "#fff",
      },
      "&:hover": {
        backgroundColor: Colors.ELEGANT_BLACK,
      },
    },
  },
}));
